import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {take} from "rxjs/operators";
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import {Router} from "@angular/router";
import {SnackBarService} from "@core/services/snack-bar.service";
import {Subject} from "rxjs";

@Component({
    standalone: false,
    selector: 'particle-fuse-splash-screen',
  templateUrl: './fuse-splash-screen.component.html',
  styleUrls: ['./fuse-splash-screen.component.scss']
})
export class FuseSplashScreenComponent implements OnInit {

  @Input() type: string;
  @Output() createMemo = new EventEmitter<boolean>();

  unSubscribe$ = new Subject<void>();
  checked: boolean;

  constructor(
    private fuseSplashScreenService: FuseSplashScreenService,
    private router: Router,
    private snackBarService: SnackBarService,
  ) {
    this.checked = false;
  }

  ngOnInit() {
  }

  orbitaxPlatformOnboardingNext(){
    this.createReport(null, this.type );
  }

  createReport(title, type) {
    this.createMemo.emit(true);
  }

  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

}
